import React from "react";
import { Switch, Route } from "react-router-dom";

import Agenda from "./pages/agenda";
import informativo from "./pages/informativo";
import Loja from "./pages/loja";
import Profissional from "./pages/profissional";
import DetalheProfissional from "./pages/profissional/components/detalhe";
import Promocao from "./pages/promocao";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Profissional} />
      <Route exact path="/profissional/:id/:share" component={Profissional} />
      <Route exact path="/loja/:id/:share" component={Loja} />
      <Route exact path="/evento/:id/:share" component={Agenda} />
      <Route exact path="/lojas" component={Loja} />
      <Route exact path="/eventos" component={Agenda} />
      <Route exact path="/informativos/:tipo" component={informativo} />
      <Route exact path="/detalhe" component={DetalheProfissional} />
      <Route exact path="/promocao/:tipo" component={Promocao} />
    </Switch>
  );
}
